import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './SideBar.scss';

const propTypes = {
  children: PropTypes.node,
  visible: PropTypes.bool.isRequired,
};
const defaultProps = {
  children: null,
};

const SideBar = ({ children, visible }) => {
  const sideBarClasses = classNames({
    'side-bar': true,
    visible,
  });

  return (
    <div className={sideBarClasses}>
      {children}
    </div>
  );
};

SideBar.propTypes = propTypes;
SideBar.defaultProps = defaultProps;

export default SideBar;



// WEBPACK FOOTER //
// ./src/components/_molecules/SideBar/SideBar.js